export const datavizSeries = [
  '#223554', // series-1: Delft Blue — primary
  '#04D1C6', // series-2: Robin Blue — secondary
  '#FE7738', // series-3: Orange — tertiary/highlight
  '#7B61FF', // series-4: Violet
  '#E85D9B', // series-5: Pink
  '#00A86B', // series-6: Green
]

export const datavizSemantic = {
  positive: '#04D1C6',
  negative: '#D63E3E',
  neutral: '#8096AE',
  baseline: '#B0C8DC',
}
